export type ManualChainPresentationPlotState = "ready" | "cleared" | "cooldown";
export type ManualChainPresentationCargoKind = "none" | "corn" | "egg";
export type ManualChainPresentationObjectiveId =
  | "pick-corn"
  | "feed-chickens"
  | "collect-eggs"
  | "sell-eggs"
  | "pen-extension-ready";

export interface FirstYardManualChainPresentationEvent {
  readonly actionId: number;
  readonly actorId: number;
  readonly id: number;
  readonly itemId: number | null;
  readonly lineageId: number | null;
  readonly plotId: number | null;
  readonly quantity: number;
  readonly sequence: number;
  readonly tick: number;
  readonly kind: string;
  readonly workOrderId: number;
}

export interface FirstYardManualChainPresentationSnapshot {
  readonly tick: number;
  readonly player: Readonly<{
    readonly position: Readonly<{ readonly x: number; readonly z: number }>;
    readonly facingRadians: number;
    readonly moving: boolean;
  }>;
  readonly interaction: Readonly<{
    readonly kind: "harvest" | "stage" | "tend" | "collect" | "sale";
    readonly progress01: number;
  }> | null;
  readonly plots: readonly Readonly<{
    readonly id: number;
    readonly state: ManualChainPresentationPlotState;
    readonly cooldown01: number;
  }>[];
  readonly cargo: Readonly<{
    readonly kind: ManualChainPresentationCargoKind;
    readonly count: number;
    readonly capacity: 5;
  }>;
  readonly pen: Readonly<{ readonly stagedCorn: number; readonly tending: boolean; readonly tend01: number }>;
  readonly nest: Readonly<{ readonly createdEggIds: readonly number[]; readonly collectedEggIds: readonly number[] }>;
  readonly market: Readonly<{ readonly salePulseId: number | null }>;
  readonly cash: number;
  readonly pad: Readonly<{ readonly state: "locked" | "active"; readonly price: 24 }>;
  readonly objectiveId: ManualChainPresentationObjectiveId;
  readonly reducedMotion: boolean;
}

export type FirstYardTrajectoryKind =
  | "harvest"
  | "stage"
  | "egg-pop"
  | "collect"
  | "sale"
  | "pad-ready"
  | "none";

export function classifyFirstYardTrajectory(kind: string): FirstYardTrajectoryKind {
  if (kind === "harvest-committed") return "harvest";
  if (kind === "stage-committed") return "stage";
  if (kind === "tend-committed") return "egg-pop";
  if (kind === "collect-committed") return "collect";
  if (kind === "sale-committed") return "sale";
  if (kind === "pen-extension-ready") return "pad-ready";
  return "none";
}
